import type { TableColumnsType } from 'antd';
import { DataTypeAR } from 'store/ducks/Reportings/types';

export const columns: TableColumnsType<DataTypeAR> = [
  {
    title: 'Name of the financial entity',
    width: 100,
    dataIndex: 'entity_name',
    key: 'entity_name',
    fixed: 'left',
  },
  {
    title: 'Functions',
    width: 100,
    dataIndex: 'function_name',
    key: 'function_name',
  },
  {
    title: 'Function name description',
    width: 100,
    dataIndex: 'function_description',
    key: 'function_description',
  },
  {
    title: 'Function level',
    width: 100,
    dataIndex: 'function_level',
    key: 'function_level',
    fixed: 'left',
  },
  {
    title: 'Third Party ICT Services',
    width: 100,
    dataIndex: 'ict_service_provider_name',
    key: 'ict_service_provider_name',
  },
  {
    title: 'ICT service level',
    width: 100,
    dataIndex: 'ict_service_level',
    key: 'ict_service_level',
  },
  {
    title: 'Selected Date',
    width: 100,
    dataIndex: 'date',
    key: 'date',
  },
  {
    title: 'Function end date',
    width: 100,
    dataIndex: 'function_end_date',
    key: 'function_end_date',
  },
  {
    title: 'Function start Date',
    width: 100,
    dataIndex: 'function_start_date',
    key: 'function_start_date',
  },
  {
    title: 'ICT Service end date',
    width: 100,
    dataIndex: 'ict_service_end_date',
    key: 'ict_service_end_date',
  },
  {
    title: 'ICT Service start date',
    width: 100,
    dataIndex: 'ict_service_start_date',
    key: 'ict_service_start_date',
  },
];
